const Nothing: React.FC = () => null;

export default Nothing;
